import React, { useContext, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import ReactModal from 'react-modal-resizable-draggable';
import { MobXProviderContext, observer } from 'mobx-react';
import { register } from '../../../i18n';
import lessonService from '../../services/LessonService';
import useAccessibilityClick from '../../../hooks/useAccessibilityClick';
import '../../../css/AltDictionary.scss';
import useReactModalResizeableDraggable from '../../../hooks/useReactModalResizeableDraggable';
import DialogPositionService from '../../services/DialogPositionService';
// Import the dictionary display component
import OxfordDictionaryDisplay from './OxfordDictionaryDisplay';

const t = register('ToolNames');
const t2 = register('GlobalQuestionLabels');

const AltDictionary = observer(() => {
  const {
    toolbarManager,
    lessonManager
  } = useContext(MobXProviderContext);

  const [searchTerm, setSearchTerm] = useState(toolbarManager.firstSelectedWord || '');
  const [hasSearched, setHasSearched] = useState(false);
  const lookupRef = useRef();
  const closeThisRef = useRef();

  useEffect(() => {
    const initializeComponent = async () => {
      await lessonService.fetchWordDefinition(toolbarManager.firstSelectedWord);
    };

    initializeComponent();
  }, []);

  // Handler for search button
  const handleSearch = async () => {
    setHasSearched(true);

    // Clean the search term by removing consecutive spaces and trimming
    const cleanedSearchTerm = searchTerm.replace(/\s+/g, ' ').trim();

    // Update the input value to reflect the cleaned term
    setSearchTerm(cleanedSearchTerm);

    await lessonService.fetchWordDefinition(cleanedSearchTerm);
  };

  useAccessibilityClick(lookupRef, async (e) => {
    await handleSearch();
  });

  useAccessibilityClick(closeThisRef, (e) => {
    toolbarManager.setIsAltDictionaryOpen(false);
  });

  useReactModalResizeableDraggable('altDictionaryTool');

  return (
    createPortal(
      <div className='altDictionaryTool'>
        <ReactModal
          disableKeystroke
          initHeight={515}
          initWidth={350}
          isOpen={true}
          left={325}
          onRequestClose={() => toolbarManager.setIsAltDictionaryOpen(false)}
          role='dialog' top={DialogPositionService.getDefaultTopPosition()}>
          <div className='dictionary-body'>
            <div className='tool-header'>
              <div className='title-label basic'>{t('dictionaryTool')}</div>
            </div>
            {/* Search box and button */}
            <div className='dictionary-search-row'>
              <input
                aria-label='Dictionary search input'
                className='dictionary-search-input'
                onChange={(e) => setSearchTerm(e.target.value)}
                type='text'
                value={searchTerm}
              />
              <button
                ref={lookupRef}
                className='submit-response primary'
                onClick={handleSearch}
              >
                {t2('search')}
              </button>
            </div>
            <div className='dictionary-wrapper'>
              {!lessonManager.childLoaded ? (
                <div className='loading-definition'>Loading definition...</div>
              ) : (
                toolbarManager.dictionaryData && toolbarManager.dictionaryData.results && toolbarManager.dictionaryData.results.length > 0 ? (
                  <OxfordDictionaryDisplay dictionaryData={toolbarManager.dictionaryData} />
                ) : (
                  hasSearched ? <div className='error-definition'>{t2('noResults')}</div> : null
                )
              )}
            </div>
            <div className='footer-buttons'>
              {/* Hide the old lookup button since we now have a search button above */}
              {/* <button ref={lookupRef} className='submit-response primary'>{t2('lookup')}</button> */}
              <button ref={closeThisRef} className='submit-response primary'>{t2('close')}</button>
            </div>
          </div>
        </ReactModal>
      </div>, document.getElementById('the-body'))
  );
});

export default AltDictionary;
